<template>
    <div class="form-group position-relative">
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <i class="far fa-calendar-alt"></i>
                </span>
            </div>
            <input type="text" class="form-control float-right" :placeholder="placeholder" :id="idPicker"
                :value="currentValue" :disabled="isReadOnly" :class="{ 'is-invalid': error }" @blur="onBlur"
                @input="onInputChange" @keydown.enter.prevent="onEnter">
        </div>

        <div class="text-danger text-right" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "TheDatePicker",
    props: {
        title: String,
        placeholder: String,
        error: String,
        minDate: {
            type: String,
            required: false,
            default: '01/01/1900',
        },
        maxDate: {
            type: String,
            required: false,
            default: '31/12/2100',
        },
        pickerId: {
            type: String,
            required: false,
        },
        startDate: {
            type: String,
            required: false,
            default: null,
        },
        endDate: {
            type: String,
            required: false,
            default: null,
        },
        isReadOnly: Boolean,
        isRequire: Boolean,
    },

    data() {
        return {
            idPicker: this.pickerId
                ? this.pickerId
                : '_' + Math.random().toString(36).substr(2, 9),
            internalStartDate: this.startDate,
            internalEndDate: this.endDate,
            currentValue: '',
            oldValue: '',
            hasChanged: false, // Biến cờ để theo dõi thay đổi
        };
    },

    watch: {
        startDate: {
            immediate: true,
            handler(newVal) {
                this.internalStartDate = newVal;
                this.updateDatePickerValue(this.internalStartDate, this.internalEndDate);
            },
        },
        endDate: {
            immediate: true,
            handler(newVal) {
                this.internalEndDate = newVal;
                this.updateDatePickerValue(this.internalStartDate, this.internalEndDate);
            },
        },
    },

    methods: {
        onInputChange(event) {
            // Đánh dấu dữ liệu đã thay đổi khi có sự kiện input
            this.hasChanged = true;
            console.log("Hihi")
            this.currentValue = event.target.value;
        },
        onEnter() {
            // Xử lý khi nhấn Enter
            this.hasChanged = false; // Reset lại cờ
            this.onInputComplete(this.currentValue);
        },
        onBlur() {
            // Chỉ xử lý khi dữ liệu đã thay đổi
            if (this.hasChanged) {
                this.onInputComplete(this.currentValue);
                this.hasChanged = false; // Reset lại cờ
            }
        },
        updateDatePickerValue(start, end) {
            const pickerSelector = `#${this.idPicker}`;
            if (start && end) {
                $(pickerSelector).val(`${start} - ${end}`);
            } else if (start && !end) {
                $(pickerSelector).val(`${start}`);
            } else if (!start && end) {
                $(pickerSelector).val(`${end}`);
            } else {
                $(pickerSelector).val('');
            }
        },
        emitValueChange(start, end) {
            if (!start && end) {
                start = end;
            }

            this.internalStartDate = start;
            this.internalEndDate = end;

            this.$emit("update:startDate", this.internalStartDate);
            this.$emit("update:endDate", this.internalEndDate);
            this.$emit("onChange", { startDate: this.internalStartDate, endDate: this.internalEndDate });

        },
        clearDate() {
            this.currentValue = '';
            this.internalStartDate = null;
            this.internalEndDate = null;
            this.$emit("update:startDate", null);
            this.$emit("update:endDate", null);
            this.$emit("onChange", { startDate: null, endDate: null });
        },
        onInputComplete(value) {
            if (!value.trim()) {
                this.clearDate();
                return;
            }

            const dates = value.split('-').map(date => date.trim());
            if (dates.length === 1) {
                if (this.isValidDate(dates[0])) {
                    this.emitValueChange(dates[0], null);
                    this.oldValue = `${dates[0]}`;
                } else {
                    this.restoreOldValue();
                }
            } else if (dates.length === 2) {
                if (this.isValidDate(dates[0]) && this.isValidDate(dates[1])) {
                    this.emitValueChange(dates[0], dates[1]);
                    this.oldValue = `${dates[0]} - ${dates[1]}`;
                } else {
                    this.restoreOldValue();
                }
            } else {
                this.restoreOldValue();
            }
        },
        restoreOldValue() {
            this.currentValue = this.oldValue;
            this.updateDatePickerValue(this.internalStartDate, this.internalEndDate);
        },
        isValidDate(date) {
            return moment(date, 'DD/MM/YYYY', true).isValid();
        },
    },

    beforeUnmount() {
        const pickerSelector = `#${this.idPicker}`;
        $(pickerSelector).off();
    },

    mounted() {
        const self = this;
        const pickerSelector = `#${this.idPicker}`;
        moment.locale('vi');

        $(pickerSelector).daterangepicker(
            {
                locale: {
                    format: 'DD/MM/YYYY',
                    separator: ' - ',
                    applyLabel: 'Chọn',
                    cancelLabel: 'Làm sạch',
                    weekLabel: 'Tuần',
                    daysOfWeek: moment.weekdaysMin(true),
                    monthNames: moment.monthsShort(),
                    firstDay: 1,
                },
                autoApply: false,
                showDropdowns: false,
                autoUpdateInput: false,
                linkedCalendars: false,
                minDate: self.minDate,
                maxDate: self.maxDate || null,
            },
            function (start, end) {
                const startDate = start.format('DD/MM/YYYY');
                const endDate = end.format('DD/MM/YYYY');
                self.currentValue = `${startDate} - ${endDate}`;
                self.oldValue = self.currentValue;
                self.emitValueChange(startDate, endDate);
            }
        );

        this.updateDatePickerValue(this.internalStartDate, this.internalEndDate);

        $(pickerSelector).on('cancel.daterangepicker', function () {
            self.currentValue = '';
            self.emitValueChange(null, null);
        });
    },
};
</script>



<style></style>
